export default "__VITE_ASSET__CF0R7OQO__"